import React from "react";
import styles from "./Input.module.scss";
import cn from "classnames";
import InputMask from 'react-input-mask';
import {Path, UseFormRegister, FieldValues} from "react-hook-form";

// Используем обобщение для поддержки различных типов
type InputProps<T extends FieldValues> = {
    label?: string;
    placeholder?: string;
    name: Path<T>;
    register: UseFormRegister<T>;
    required?: boolean;
    errorMessage?: string;
    mask?: string;
    value?: string | number;
    type?: string;
    className?: string;
};

const Input = <T extends FieldValues>({
                                          label,
                                          placeholder,
                                          name,
                                          register,
                                          required,
                                          errorMessage,
                                          mask,
                                          value,
                                          type,
                                          className
                                      }: InputProps<T>) => {
    return (
        <div className={cn(
            styles.inputGroup,
            errorMessage ? styles.inputError : undefined,
            className ? styles[className] : undefined,
        )}>
            <label className={styles.inputLabel} htmlFor={name}>
                {label}
            </label>
            {type === "hidden" ? (
                <input
                    id={name}
                    className={styles.inputControl}
                    placeholder={placeholder}
                    type="hidden"
                    value={value}
                    {...register(name, {required})}
                />
            ) : mask ? (
                <InputMask
                    id={name}
                    className={styles.inputControl}
                    placeholder={placeholder}
                    type={type}
                    mask={mask}
                    value={value}
                    {...register(name, {required})}
                />
            ) : (
                <input
                    id={name}
                    className={styles.inputControl}
                    placeholder={placeholder}
                    type={type}
                    value={value}
                    {...register(name, {required})}
                />
            )}
            {errorMessage && <span className={styles.errorMessage}>{errorMessage}</span>}
        </div>
    );
};

export default Input;
